import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getParkFullConfig(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config`)
  if (!response.ok) throw new Error('Error al obtener la configuración')
  return response.json()
}

export async function saveIdentity(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/identity`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar')
  return response.json()
}

export async function saveLocation(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/location`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar la ubicación')
  return response.json()
}

export async function saveBankDetails(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/bank`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar')
  return response.json()
}

export async function savePhysical(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/physical`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar')
  return response.json()
}

export async function uploadLogo(parkId, file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/logo`, { method: 'POST', body: formData })
  if (!response.ok) throw new Error('Error al subir el logo')
  return response.json()
}

export async function deleteLogo(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/logo`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el logo')
  return response.json()
}

export async function addZone(parkId, name) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/zones`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name }),
  })
  if (!response.ok) throw new Error('Error al agregar la zona')
  return response.json()
}

export async function renameZone(parkId, zoneId, name) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/zones/${zoneId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name }),
  })
  if (!response.ok) throw new Error('Error al renombrar la zona')
  return response.json()
}

export async function deleteZone(parkId, zoneId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/zones/${zoneId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar la zona')
  return response.json()
}

export async function getBillingConfig(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/billing-rules`)
  if (!response.ok) throw new Error('Error al obtener la configuración')
  return response.json()
}

export async function saveBillingConfig(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/billing-rules`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar la configuración')
  return response.json()
}

export async function getProviders(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/providers`)
  if (!response.ok) throw new Error('Error al obtener los proveedores')
  return response.json()
}

export async function createProvider(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/providers`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al crear el proveedor')
  return response.json()
}

export async function updateProvider(parkId, providerId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/providers/${providerId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar el proveedor')
  return response.json()
}

export async function deleteProvider(parkId, providerId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/providers/${providerId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el proveedor')
  return response.json()
}

export async function searchProviders(parkId, query, category) {
  const params = new URLSearchParams({ q: query })
  if (category) params.set('category', category)
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/providers-search?${params.toString()}`)
  if (!response.ok) throw new Error('Error al buscar proveedores')
  return response.json()
}

export async function getServiceTypes(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/service-types`)
  if (!response.ok) throw new Error('Error al obtener los tipos de servicio')
  return response.json()
}

export async function addCustomServiceType(parkId, name) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/service-types`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name }),
  })
  if (!response.ok) throw new Error('Error al agregar el tipo')
  return response.json()
}

export async function deleteCustomServiceType(parkId, typeId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/service-types/${typeId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el tipo')
  return response.json()
}

export async function getNotificationConfig(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/notifications`)
  if (!response.ok) throw new Error('Error al obtener la configuración')
  return response.json()
}

export async function saveGlobalChannels(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/notifications/global`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar')
  return response.json()
}

export async function saveEventConfig(parkId, eventKey, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/notifications/events/${eventKey}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar el evento')
  return response.json()
}

export async function getWhatsAppConfig(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp`)
  if (!response.ok) throw new Error('Error al obtener la configuración')
  return response.json()
}

export async function saveWhatsAppConfig(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar')
  return response.json()
}

export async function addWhatsAppKeyword(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp/keywords`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al agregar')
  return response.json()
}

export async function updateWhatsAppKeyword(parkId, keywordId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp/keywords/${keywordId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar')
  return response.json()
}

export async function deleteWhatsAppKeyword(parkId, keywordId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp/keywords/${keywordId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar')
  return response.json()
}

export async function getWhatsAppStatus(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/config/whatsapp/status`)
  if (!response.ok) throw new Error('Error al obtener el estatus')
  return response.json()
}